import { request } from 'api/request';
import { EmailDeliveryStatus } from 'api/types';

export const loadEmailDelivery = async (actionId: string) => {
  const response = await request.get<{ emailDelivery: EmailDeliveryStatus[] | null }>(
    `v1/emails/delivery/${actionId}/`
  );
  return response.data.emailDelivery;
};
